import { MdShare } from "react-icons/md";

const ShareButton = ({ variant = "floating" }) => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Tap2Cash",
          url: window.location.href,
        });
        console.log("Thanks for sharing!");
      } catch (err) {
        console.error("Error while using Web Share API:", err);
      }
    } else {
      alert("Browser doesn't support this API!");
    }
  };

  const className =
    variant === "floating"
      ? "fixed z-50 p-4 text-white transition duration-300 rounded-full shadow-lg bottom-6 right-6 bg-emerald-600 hover:bg-emerald-700"
      : "inline-flex items-center p-1 rounded bg-fuchsia-100 gap-1 text-fuchsia-700 hover:text-fuchsia-900  text-sm font-medium";

  return (
    <button
      id="shareBtn"
      onClick={handleShare}
      className={className}
      title="Share this page"
    >
      <MdShare className={variant === "floating" ? "text-xl" : "text-2xl"} />
      {variant === "inline" && <span>Share</span>}
    </button>
  );
};

export default ShareButton;
